import { AnaColumn } from "../forms-template.service";

export const crmDiarioAttivitaGrid: AnaColumn[] = [


  {
    configuration:
    {
      service: 'crmDiarioAttivitaContatto',
      api: 'diario',
      api_rest: true,
      filterList: '',
      filterEditor: '/$',
      // helpDoc: 'Movimentidicaricoescaricorifiuti.html',
      formType: 'simple',
      queryFilter: [],
      idTabRif: [],
      costantValues: [
        { key: 'UtenteCheInserisce', value: 'UtenteLoggato' },
        { key: 'DataInserimento', value: 'DataOggi' }
      ],
      masterKey: 'id',
      nCol: 1,

      //ListaHP=H12&ListaHP=H2&ListaHP=H4&
    },

    itemType: "group", colCount: "1", class: "", caption: "Diario Attività",
    data: [
      {
        type: 'campo',
        dataField: 'CodContatto',
        colVisible: false,
        visible: false,
        dataType: 'string',
        caption: 'CodContatto',
        colAlignment: 'center',
      },

      {
        type: 'campo',
        dataField: 'CodSede',
        colVisible: false,
        visible: false,
        dataType: 'string',
        caption: 'CodSede',
        colAlignment: 'center',
      },

      {
        type: 'campo',
        dataField: 'id',
        colVisible: false,
        visible: false,
        dataType: 'string',
        caption: 'ID',
        labelPosition: 'center',
        width: 40,
        colWidth: '40px'
      },
      {
        type: 'campo',
        dataField: 'UtenteCheInserisce',
        colVisible: false,
        disabled: true,
        readonly: true,
        disableOnUpdate: true,
        showDropDownButton: false,
        class: 'disabileVisibile pe-none',
        dataType: 'string',
        caption: 'Inserito da',
        colAlignment: 'left',
        colWidth: 150

      },
      {
        type: 'campo',
        dataField: 'UtenteCheConclude',
        colVisible: false,
        disabled: true,
        readonly: true,
        disableOnUpdate: true,
        showDropDownButton: false,
        class: 'disabileVisibile pe-none',
        dataType: 'string',
        caption: 'Concluso da',
        colAlignment: 'left',
        colWidth: 150

      },

      {
        type: 'campo',
        dataField: 'Stato',
         orderGriglia:5,
        colVisible: true,
        visible: false,
        dataType: 'number',
        caption: 'Stato',
        colAlignment: 'left',
        width: 90,
        defaultValue: 1,
        lista: {
          dataSource: 'statiDiario',
          displayExpr: 'value',
          valueExpr: 'key',
          static: true,
        }
      },
      {
        type: 'campo',
        dataField: 'assegnato_a',
         orderGriglia:4,
        colVisible: true,
        visible: true,
        dataType: 'string',
        caption: 'Assegnato a',
        colAlignment: 'left',
        width: 150,
        lista: {
          dataSource: 'account?$orderBy=nomeCompleto',
          displayExpr: 'nomeCompleto',
          valueExpr: 'id',
          wingap: true,
          static: false,
          costantValues: [],
        }
      },


      {
        type: 'campoData',
        dataField: 'DataInserimento',
        dataType: 'datetime',
        format: "dd/MM/yyyy HH:mm",
        editorType: "dxDateBox",
        showClearButton: true,
        showDropDownButton: false,
        disabled: true,
        disableOnUpdate: true,
        readonly: true,
        colVisible: true,
        class: 'pe-none',
        orderGriglia:1,
        caption: 'Data evento',
        colAlignment: 'center',
        colWidth: 120

      },
      {
        type: 'campoData',
        dataType: 'datetime',
        dataField: 'DataConclusione',
        format: "dd/MM/yyyy HH:mm",
        editorType: "dxDateBox",
        showClearButton: true,
        showDropDownButton: false,
        disabled: true,
        disableOnUpdate: true,
        readonly: true,
        colVisible: true,
        class: 'pe-none',
         orderGriglia:6,
        caption: 'Data Applicazione',
        colAlignment: 'center',
        colWidth: 120
      },

      {
        type: 'campo',
        dataField: 'Tipo',
        colVisible: true,
        visible: true,
        dataType: 'string',
        caption: 'Tipo',
         orderGriglia:3,
        colAlignment: 'left',
        width: 120,
        editorType: 'dxSelectBox',
        lista: {
          dataSource: 'tabella',
          displayExpr: 'descrizione',
          valueExpr: 'id',
          queryString: '?tipo=9',
          wingap: false,
          static: false,
          costantValues: [
            { key: 'tipo', value: 9 }
          ]
        }
      },

      {
        type: 'campo',
        dataField: 'fonte',
        colVisible: false,
        visible: false,
        dataType: 'string',
        caption: 'Fontesss',
        colAlignment: 'left',
        width: 100,
        lista: {
          dataSource: "tabella?tipo=22",
          //queryString: "?tipo=22",
          displayExpr: 'descrizione',
          valueExpr: 'id',
          wingap: false,
          static: false,
          costantValues: [
            { key: 'tipo', value: 22 }
          ]
        }
      },

      {
        type: 'campo',
        dataField: 'Descrizione',
        colVisible: true,
        dataType: 'string',
        caption: 'Descrizione',
        allowEditing: true,
        colAlignment: 'left',
         orderGriglia:2,

      },

      {
        type: 'campo',
        dataField: 'Soluzione',
        colVisible: false,
        dataType: 'string',
        caption: 'Soluzione',
        allowEditing: true,
        colAlignment: 'left',

      },
    ]
  },
];

export const crmDiarioAttivitaContatto: AnaColumn[] = [


  {
    configuration:
    {
      service: 'crmDiarioAttivitaContatto',
      api: '',
      api_rest: true,
      filterList: '',
      filterEditor: '/$',
      // helpDoc: 'Movimentidicaricoescaricorifiuti.html',
      formType: 'simple',
      queryFilter: [],
      idTabRif: [],
      masterKey: 'id',
      nCol: 1,
      widthForm: 700,

      //ListaHP=H12&ListaHP=H2&ListaHP=H4&
    },

    itemType: "group", colCount: "2", class: "", caption: "Diario Attività",
    data: [
      {
        type: 'campo',
        dataField: 'id',
        colVisible: false,
        visible: false,
        dataType: 'string',
        caption: 'id',
        colAlignment: 'center',
      },
      {
        type: 'campo',
        dataField: 'CodContatto',
        colVisible: false,
        visible: false,
        dataType: 'string',
        caption: 'CodContatto',
        colAlignment: 'center',
      },

      {
        type: 'campo',
        dataField: 'CodSede',
        colVisible: false,
        visible: false,
        dataType: 'string',
        caption: 'CodSede',
        colAlignment: 'center',
      },
      {
        type: 'campoData',
        dataType: 'datetime',
        dataField: 'DataInserimento',
        format: "dd/MM/yyyy HH:mm",
        editorType: "dxDateBox",
        showClearButton: true,
        showDropDownButton: false,
        disabled: true,
        disableOnUpdate: true,
        colVisible: true,
        caption: 'Data evento',
        colAlignment: 'center',
        class: 'disabileVisibile crm_editor ',
        nCol: 5,
      },
      { type: 'empty' },
     {
        type: 'campo',
        dataField: 'Descrizione',
        colVisible: true,
        dataType: 'string',
        caption: 'Descrizione',
        allowEditing: true,
        colAlignment: 'left',
        editorType: 'dxTextArea',
        class: 'crm_editor ',
        nCol: 10
      },
      { type: 'empty' },
      {
        type: 'campo',
        dataField: 'Tipo',
        colVisible: true,
        visible: true,
        disableOnUpdate: true,
        dataType: 'string',
        caption: 'Tipo',
        colAlignment: 'left',
        class: 'crm_editor ',
        nCol: 5,
        editorType: 'dxSelectBox',
        dynamic: {
          valueExpr: 'id',
          queryString: '?tipo=9',
          displayExpr: 'descrizione',
          campoTabRif: 'id',
          dataSource: 'tabella',
          service: '',
          autocomplete: false,
          caption: 'Lista Tipi',
          filterStatic: "",
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Lista',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Tipi',
            name: 'Loc',
            location: 'after',
          },
          settingGrid: {
            masterKey: 'id',
            keyUnique: '',
            wingap: false,
            mode: 'cell',
            selectionMode: 'single',
            remoteOperations: true,
            hoverStateEnabled: true,
            rowAlternationEnabled: true,
            repaintChangesOnly: true,
            showFilterSearch: false,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            height: 630,
            showColBlank: false,
            campoTabRif: '',
            searchAndSelect: true, //Cerca Valore e seleziona
            searchType: 'contains',
            width: 600,
            toolbarButtonsBottomLeft: null,
            toolbarButtonsBottomRight: [0],
            isOdata: false,
            overrideDataSource: null,
            concatDataField: null,
            colonne: [
              {
                dataField: 'id',
                dataType: '',
                caption: 'Codice',
                allowEditing: true,
                colVisible: false
              },
              {
                dataField: 'descrizione',
                dataType: '',
                caption: 'Descrizione',
                allowEditing: true,
              },
            ],
          },
        },
      },
       {
        type: 'campo',
        dataField: 'assegnato_a',
        colVisible: true,
        visible: true,
        dataType: 'string',
        caption: 'Assegnato a',
        disableOnUpdate: true,
        colAlignment: 'center',
        nCol: 5,
        class: 'crm_editor ',
        editorType: 'dxSelectBox',
        dynamic: {
          valueExpr: 'id',
          displayExpr: 'nomeCompleto',
          campoTabRif: 'id',
          dataSource: 'account',
          service: '',
          autocomplete: false,
          caption: 'Lista Assegnatori',
          filterStatic: "",
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Lista',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Assegnatori',
            name: 'Loc',
            location: 'after',
          },
          settingGrid: {
            masterKey: 'id',
            keyUnique: '',
            wingap: true,
            mode: 'cell',
            selectionMode: 'single',
            remoteOperations: true,
            hoverStateEnabled: true,
            rowAlternationEnabled: true,
            repaintChangesOnly: true,
            showFilterSearch: false,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            height: 630,
            showColBlank: false,
            campoTabRif: '',
            searchAndSelect: true, //Cerca Valore e seleziona
            searchType: 'contains',
            width: 600,
            toolbarButtonsBottomLeft: null,
            toolbarButtonsBottomRight: [0],
            isOdata: false,
            overrideDataSource: null,
            concatDataField: null,
            colonne: [
              {
                dataField: 'id',
                dataType: '',
                caption: 'Codice',
                allowEditing: true,
                colVisible: false
              },
              {
                dataField: 'nomeCompleto',
                dataType: 'string',
                caption: 'Operatore',
                allowEditing: true,
              },
              {
                dataField: 'userName',
                dataType: 'string',
                caption: 'E-Mail',
                allowEditing: true,
              },
              {
                dataField: 'telefono',
                dataType: 'string',
                caption: 'Telofono',
                allowEditing: true,
              },
            ],
          },
        },
      },
      {
        type: 'campo',
        dataField: 'Stato',
        colVisible: true,
        visible: true,
        dataType: 'string',
        caption: 'Stato',
        colAlignment: 'center',
        class: 'crm_editor ',
        nCol: 5,
        editorType: 'dxSelectBox',
        lista: {
          dataSource: 'statiDiario',
          selectFirstElement: true,
          displayExpr: 'value',
          valueExpr: 'key',
          static: true,
          costantValues: [],
          isDefaultOption: false
        }
      },
     
      
      {
        type: 'campo',
        dataField: 'DataConclusione',
        colVisible: true,
        dataType: 'datetime',
        format: "dd/MM/yyyy HH:mm",
        editorType: "dxDateBox",
        showClearButton: true,
        showDropDownButton: true,
        caption: 'Data Applicazione',
        colAlignment: 'center',
        nCol: 5,
        class: 'crm_editor ',
      },
      {
        type: 'campo',
        dataField: 'fonte',
        colVisible: true,
        visible: false,
        dataType: 'string',
        caption: 'Fonte',
        colAlignment: 'center',
        class: 'crm_editor ',
        editorType: 'dxSelectBox',
        nCol: 5,
        lista: {
          dataSource: "tabella",
          queryString: "?tipo=22",
          displayExpr: 'descrizione',
          valueExpr: 'id',
          static: false,
          wingap: false,
          costantValues: [],
          isDefaultOption: false,
        }
      },


      

      {
        type: 'campo',
        dataField: 'UtenteCheInserisce',
        visible: false,
        disabled: true,
        disableOnUpdate: true,
        showClearButton: false,
        class: 'disabileVisibile crm_editor',
        dataType: 'string',
        caption: 'Inserito da',
        colAlignment: 'left',
        nCol: 5
      },
      {
        type: 'campo',
        dataField: 'UtenteCheConclude',
        visible: false,
        disabled: true,
        disableOnUpdate: true,
        showClearButton: false,
        class: 'disabileVisibile crm_editor',
        dataType: 'string',
        caption: 'Concluso da',
        colAlignment: 'left',
        nCol: 5
      },
      

      { type: 'empty' },

      /*  */
      {
        type: 'campo',
        dataField: 'Soluzione',
        colVisible: true,
        visible: false,
        dataType: 'string',
        caption: 'Soluzione',
        allowEditing: true,
        colAlignment: 'left',
        editorType: 'dxTextArea',
        class: 'crm_editor ',
        nCol: 10
      },

      { type: 'empty' },
    ]
  },
];